import DeleteIcon from '@mui/icons-material/Delete'
import InfoIcon from '@mui/icons-material/Info'
import { Box, IconButton, Link, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FileUploadArea } from '~/src/components/molecules/Form/FileUploader/FireUploadArea'

const Section = styled('section')({})

interface IUploadFile {
  onSaveFile: (file: File) => void
  onDeleteFile: () => void
  file?: {
    filename: string
    url: string
  }
  isLoading: boolean
}

export const UploadFile: React.FC<IUploadFile> = ({
  onSaveFile,
  onDeleteFile,
  file,
  isLoading,
}) => {
  const { t } = useTranslation()
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return
    onSaveFile(e.target.files[0])
  }

  const handleClearImage = () => {
    onDeleteFile()
  }

  return (
    <Section>
      {isLoading && (
        <Box display={'flex'} alignItems={'center'}>
          <IconButton color={'success'}>
            <InfoIcon />
          </IconButton>
          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: 14,
            }}
          >
            Uploading...
          </Typography>
        </Box>
      )}
      {file && !isLoading && (
        <Box display={'flex'} alignItems={'center'}>
          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: 16,
              color: '#1F4266',
              mr: 1,
            }}
          >
            <Link href={file.url}>{file.filename}</Link>
          </Typography>
          <IconButton size={'small'} aria-label="delete" color="default" onClick={handleClearImage}>
            <DeleteIcon />
          </IconButton>
        </Box>
      )}
      {!file && !isLoading && (
        <FileUploadArea
          uploadLabelText={t('proforma_invoice.drop_your_files_here_or')}
          uploadButtonText={t('proforma_invoice.upload')}
          isDisabled={false}
          handleFileChange={handleFileChange}
        />
      )}
    </Section>
  )
}
